async function loadPolyfills() {
  // @ts-ignore
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

export default loadPolyfills;
